import React from 'react';
import { Link } from 'react-router-dom';
import { ShieldCheck } from 'lucide-react';
import logoImg from '../img/Untitled design (19).png';
import BackgroundLayout from '../components/BackgroundLayout';
import { buildWhatsAppUrl, WHATSAPP_MESSAGES } from '../services/contact';
import './Auth.css';

export default function Register() {
  const whatsappUrl = buildWhatsAppUrl(WHATSAPP_MESSAGES.enrollment);

  return (
    <BackgroundLayout>
      <div className="auth-page" dir="rtl">
        <div className="auth-container enrollment-container">
          <section className="auth-card enrollment-card" aria-labelledby="enrollment-title">
            <header className="auth-header enrollment-header">
              <img
                src={logoImg}
                alt="CodeWave"
                className="auth-logo-img"
                width="84"
                height="84"
                loading="eager"
              />
              <div className="enrollment-badge">
                <ShieldCheck size={17} aria-hidden="true" />
                حسابات مفعّلة للطلاب المشتركين
              </div>
              <h1 id="enrollment-title" className="auth-title">التسجيل في منصة CodeWave</h1>
              <p className="enrollment-lead">المنصة مخصصة لطلاب CodeWave المشتركين بالفعل</p>
            </header>

            <p className="enrollment-copy">
              لو حابب تشترك معانا أو تحصل على حساب للمنصة، تواصل مع فريق CodeWave على واتساب وسنساعدك في خطوات الاشتراك وتفعيل حسابك.
            </p>

            <a
              className="whatsapp-enrollment-cta"
              href={whatsappUrl}
              target="_blank"
              rel="noopener noreferrer"
            >
              <svg viewBox="0 0 32 32" aria-hidden="true" focusable="false">
                <path
                  fill="currentColor"
                  d="M16.01 3.2c-7.05 0-12.79 5.73-12.79 12.78 0 2.25.59 4.45 1.72 6.38L3.1 29.03l6.84-1.8a12.7 12.7 0 0 0 6.07 1.55h.01c7.05 0 12.78-5.74 12.78-12.79 0-3.41-1.33-6.62-3.75-9.04A12.67 12.67 0 0 0 16.01 3.2Zm0 23.42h-.01c-1.92 0-3.8-.52-5.44-1.5l-.39-.23-4.06 1.07 1.08-3.95-.26-.41a10.6 10.6 0 0 1-1.62-5.62c0-5.9 4.8-10.7 10.71-10.7 2.86 0 5.55 1.11 7.57 3.14a10.62 10.62 0 0 1 3.13 7.57c0 5.9-4.8 10.63-10.71 10.63Zm5.87-8c-.32-.16-1.9-.94-2.2-1.04-.29-.11-.5-.16-.72.16-.21.32-.83 1.04-1.02 1.26-.19.21-.38.24-.7.08-.32-.16-1.36-.5-2.59-1.6-.96-.85-1.61-1.91-1.8-2.23-.19-.32-.02-.49.14-.65.15-.14.32-.38.48-.56.16-.19.21-.32.32-.54.11-.21.05-.4-.03-.56-.08-.16-.72-1.73-.99-2.37-.26-.62-.52-.54-.72-.55h-.61c-.21 0-.56.08-.86.4-.29.32-1.12 1.09-1.12 2.66s1.15 3.09 1.31 3.3c.16.21 2.26 3.45 5.47 4.84.76.33 1.36.53 1.82.68.77.24 1.47.21 2.02.13.62-.09 1.9-.78 2.17-1.52.27-.75.27-1.39.19-1.52-.08-.14-.29-.22-.61-.38Z"
                />
              </svg>
              <span>تواصل معنا على واتساب</span>
            </a>

            <p className="enrollment-reassurance">فريقنا هيساعدك في الاشتراك وتفعيل حسابك</p>

            <div className="auth-footer enrollment-footer">
              لديك حساب بالفعل؟ <Link to="/login" className="auth-link">تسجيل الدخول</Link>
            </div>
          </section>
        </div>
      </div>
    </BackgroundLayout>
  );
}
